"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ContentBase = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ChromelessControl = _interopRequireDefault(require("./ChromelessControl"));

var _Context = require("./Context");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var HIDE_CHROME_DELAY = 500;

var ContentBase = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(ContentBase, _React$PureComponent);

  var _super = _createSuper(ContentBase);

  function ContentBase() {
    var _this;

    (0, _classCallCheck2["default"])(this, ContentBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnter", function () {
      var _this$props = _this.props,
          chromelessFloating = _this$props.chromelessFloating,
          hasOpenMenu = _this$props.hasOpenMenu,
          setChromelessFloating = _this$props.setChromelessFloating;

      if (chromelessFloating && !hasOpenMenu) {
        _this.chromelessTimer = setTimeout(function () {
          setChromelessFloating(false);
        }, HIDE_CHROME_DELAY);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeave", function () {
      _this.clearChromelessTimer();
    });
    return _this;
  }

  (0, _createClass2["default"])(ContentBase, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearChromelessTimer();
    }
  }, {
    key: "clearChromelessTimer",
    value: function clearChromelessTimer() {
      if (this.chromelessTimer) {
        clearTimeout(this.chromelessTimer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          chromeless = _this$props2.chromeless,
          chromelessFloating = _this$props2.chromelessFloating,
          full = _this$props2.full,
          inverted = _this$props2.inverted;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('cloud-ui-page-content', {
          full: full,
          inverted: inverted
        }),
        onMouseEnter: chromeless ? this.onMouseEnter : undefined,
        onMouseLeave: chromeless ? this.onMouseLeave : undefined
      }, chromeless && !chromelessFloating && /*#__PURE__*/_react["default"].createElement(_ChromelessControl["default"], null), children);
    }
  }]);
  return ContentBase;
}(_react["default"].PureComponent);

exports.ContentBase = ContentBase;

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_Context.ContextConsumer, null, function (_ref) {
    var chromeless = _ref.chromeless,
        chromelessFloating = _ref.chromelessFloating,
        setChromelessFloating = _ref.setChromelessFloating,
        hasOpenMenu = _ref.hasOpenMenu;
    return /*#__PURE__*/_react["default"].createElement(ContentBase, (0, _extends2["default"])({}, props, {
      chromeless: chromeless,
      chromelessFloating: chromelessFloating,
      setChromelessFloating: setChromelessFloating,
      hasOpenMenu: hasOpenMenu
    }));
  });
};

exports["default"] = _default;